<h2 mat-dialog-title>Select Event</h2>

<form [formGroup]="RoleForm" (ngSubmit)="onFormSubmit()">
    <div mat-dialog-content class="content">
        <div class="row">
            <mat-form-field class="selectevent">
                <mat-select [(ngModel)]="selectedValue" formControlName="selectedValue" placeholder="Select Event">
                    <mat-option *ngFor="let data of eventmain"
                        [value]="{ event_id: data.event_id, so_event_id: data.so_event_id, role: data.role }">
                        {{ data.event_name }}
                    </mat-option>
                    <!-- <mat-option value="0">All Event</mat-option> -->
                </mat-select>
                <mat-error *ngIf="RoleForm.controls['selectedValue'].invalid">
                    Please select an event
                </mat-error>
            </mat-form-field>
        </div>

        <div mat-dialog-actions class="action" align="end">
            <button mat-stroked-button color="warn" type="button" (click)="onSkip()">Skip</button>
            <button mat-raised-button type="submit" color="primary" [disabled]="!RoleForm.valid">Submit</button>
        </div>
    </div>
</form>